import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

import { AdminPageLayout } from '@confluence/site-permissions/entry-points/AdminPageLayout.ts';
import { AdminControls } from '@confluence/team-admin-controls/entry-points/AdminControls.ts';

export const AdminTeamControlsRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		sideNavigationId: string;
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => {
	return (
		<AdminPageLayout>
			<AdminControls />
		</AdminPageLayout>
	);
};

AdminTeamControlsRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	sideNavigationId: string;
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'adminTeamControlsSettings' },
	},
	sideNavigationId: ADMIN_HOME_ID,
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
